import { EditOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import React from 'react'

type EditActionButtonProps = {
  handleEdit: () => void
}

export function EditActionButton({ handleEdit }: EditActionButtonProps) {
  return (
    <div>
      <Tooltip title='Edit supply outage'>
        <Button type='text' icon={<EditOutlined />} onClick={handleEdit} />
      </Tooltip>
    </div>
  )
}
